import { render } from "./ProjectManager.vue?vue&type=template&id=27862ca3&ts=true"
import script from "./ProjectManager.vue?vue&type=script&lang=ts"
export * from "./ProjectManager.vue?vue&type=script&lang=ts"

import "./ProjectManager.vue?vue&type=style&index=0&id=27862ca3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__